module.exports = __webpack_public_path__ + "static/media/locked-poster.b48fe5f8.png";